/*=========================================================================================
  File Name: moduleOpportuniteState.js
  Description: Opportunite Module State
  ----------------------------------------------------------------------------------------
==========================================================================================*/

export default {
  opportunites: []
}